module.exports = __webpack_public_path__ + "media/images/icons/linkedin_blue-06fa18aed331c76500b8ef31c147b6bf.svg";